import app from "firebase/app";
import "firebase/auth";
import env from "environment";
import { getAuthSignInProvider } from "./AuthService";
import Store from "../../store";
import actionCreators from "../../schema-form/action-creators";
import endpoints from "./../../configs/endpoints";
import userActions from "action-creators/user";
import { t1 } from "../../i18n";
import { notification } from "antd";

function Firebase() {
  this.app = app.initializeApp({
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    authDomain: env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.REACT_APP_FIREBASE_APP_ID,
    measurementId: env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  });
  this.auth = app.auth();
  this.authStateChangedCallback = null;

  const self = this;

  this.signIn = async (provider, data) => {
    try {
      if (this.auth.currentUser !== null) {
        this.auth.signOut();
      }

      const executeProvider = getAuthSignInProvider(provider);
      const response = await executeProvider(this.auth, data);
      const token = await response.user.getIdToken();

      return { user: response.user, token };
    } catch (error) {
      return { error };
    }
  };

  this.signUp = async (inputData) => {
    try {
      const credentials = await this.auth.createUserWithEmailAndPassword(
        inputData.email,
        inputData.password,
      );

      const token = await credentials.user.getIdToken();

      return new Promise((resolve, reject) => {
        Store.dispatch(actionCreators.handleSummitForm(endpoints.user.login, "post", {
         token,
       }, {
         dispatchAfterSuccess: (loginData) => userActions.onLoginSuccess({
           ...loginData,
           refreshToken: credentials.user.refreshToken,
         }),
         onSuccess: () => {
          resolve(token);
         },
         onFail: () => {
           this.auth.signOut();
           reject();
         },
       }));
      });
    } catch (error) {
      if (error.code === "auth/email-already-in-use") {
        const methods = await this.auth.fetchSignInMethodsForEmail(inputData.email);

        notification.warning({
          message: t1("Email already in use"),
          description: t1(`Your email is setting with ${methods[0]} provider`),
        });
      } else {
        notification.warning({
          message: t1(error.code),
          description: t1(error.message),
        });
      }
    }
  };

  this.setAuthStateListener = (callback) => {
    this.authStateChangedCallback = callback;
  };

  this.auth.onAuthStateChanged(async (user) => {
    if (user) {
      const token = await user.getIdToken();
      if (typeof (self.authStateChangedCallback) === "function") {
        self.authStateChangedCallback(user, token);
      }
      // User is signed in.
    } else if (typeof (self.authStateChangedCallback) === "function") {
      self.authStateChangedCallback(null, null);
      // No user is signed in.
    }
  });
}


const useFirebase = new Firebase();

export default useFirebase;
